// removed by extract-text-webpack-plugin
module.exports = {"index":"_3_pv","label":"_3Lpn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/listarrow/style.css
// module id = 153
// module chunks = 9